export const messages = {
    "wr-dashboard.search.input.hint": "Tìm kiếm",
    "wr-dashboard.search.label.breadcrumb": "Kết quả tìm kiếm",
    "wr-dashboard.search.message.empty": "Không có mục nào khớp với nội dung tìm kiếm của bạn",
    "wr-dashboard.side-bar.selected.title:plural": "Đã chọn {count} mục | Đã chọn {count} mục",
    "wr-dashboard.side-bar.backup-type.disk": "Ổ đĩa",
    "wr-dashboard.side-bar.backup-type.file": "Tệp",
    "wr-dashboard.side-bar.backup-type.notarized": "Tệp và thư mục được chứng thực",
    "wr-dashboard.side-bar.backup-type.exchange": "Ứng dụng - Microsoft Exchange",
    "wr-dashboard.side-bar.backup-type.sql": "Ứng dụng - Microsoft SQL",
    "wr-dashboard.side-bar.backup-type.sys-state": "Ứng dụng - Trạng thái hệ thống",
    "wr-dashboard.side-bar.backup-type.application": "Ứng dụng",
    "wr-dashboard.backups-table.column.name": "Tên",
    "wr-dashboard.backups-table.column.size": "Kích cỡ",
    "wr-dashboard.backups-table.column.version": "Phiên bản gần nhất",
    "wr-dashboard.backups-table.action.delete": "Xóa",
    "wr-dashboard.backups-table.message.no-backups": "Chưa có bản sao lưu nào trong Đám mây",
    "wr-dashboard.backups-sidebar.label.size": "Kích cỡ",
    "wr-dashboard.backups-sidebar.label.type": "Loại",
    "wr-dashboard.backups-sidebar.label.version": "Phiên bản gần nhất",
    "wr-dashboard.backups-sidebar.label.created": "Đã tạo",
    "wr-dashboard.backups-sidebar.label.machine": "Máy",
    "wr-dashboard.backups-sidebar.label.owner": "Chủ sở hữu",
    "wr-dashboard.content-table.column.name": "Tên",
    "wr-dashboard.content-table.column.versions": "Phiên bản",
    "wr-dashboard.content-table.column.volumes": "Khu vực lưu trữ",
    "wr-dashboard.content-table.column.path": "Đường dẫn",
    "wr-dashboard.content-table.column.size": "Kích cỡ",
    "wr-dashboard.content-table.column.version": "Phiên bản gần nhất",
    "wr-dashboard.content-table.action.notary-verify": "Xác minh",
    "wr-dashboard.content-table.action.notary-get-crt": "Tải chứng chỉ",
    "wr-dashboard.content-table.action.asign": "Gửi để ký",
    "wr-dashboard.content-table.action.versions": "Phiên bản",
    "wr-dashboard.content-table.action.restore": "Tải xuống",
    "wr-dashboard.content-table.label.size": "Kích cỡ",
    "wr-dashboard.content-table.label.created": "Đã tạo",
    "wr-dashboard.content-table.label.modified": "Đã sửa đổi",
    "wr-dashboard.content-table.message.empty-folder": "Thư mục này trống",
    "wr-dashboard.password-dialog-box.title.backup": "Bản sao lưu được mã hóa",
    "wr-dashboard.password-dialog-box.title.archive": "Bản lưu trữ được mã hóa",
    "wr-dashboard.password-dialog-box.message.backup": "Vui lòng cho biết mật khẩu để truy cập bản sao lưu {displayName}",
    "wr-dashboard.password-dialog-box.message.archive": "Vui lòng cho biết mật khẩu để truy cập bản lưu trữ {displayName}",
    "wr-dashboard.password-dialog-box.hint.password": "Mật khẩu",
    "wr-dashboard.password-dialog-box.message.invalid-password": "Mật khẩu không chính xác",
    "wr-dashboard.form.button.open": "Mở",
    "wr-dashboard.form.button.close": "Đóng",
    "wr-dashboard.form.button.cancel": "Hủy",
    "wr-dashboard.form.button.continue": "Tiếp tục",
    "wr-dashboard.form.button.proceed": "Tiếp tục",
    "wr-dashboard.form.button.delete": "Xóa",
    "wr-dashboard.form.button.done": "Xong",
    "wr-dashboard.form.button.retry": "Thử lại",
    "wr-dashboard.notary.verify.view.status.downloading": "Đang tải xuống...",
    "wr-dashboard.notary.verify.view.status.validating": "Đang xác thực...",
    "wr-dashboard.notary.verify.view.status.pending": "Chứng chỉ đang chờ xử lý...",
    "wr-dashboard.notary.verify.view.status.fail": "Không khớp với chứng chỉ...",
    "wr-dashboard.notary.verify.view.button.get-crt": "Tải chứng chỉ",
    "wr-dashboard.notary.verify.view.file-info.name": "TÊN",
    "wr-dashboard.notary.verify.view.file-info.signed-by": "NGƯỜI KÝ",
    "wr-dashboard.notary.verify.view.file-info.date-backed-up": "NGÀY SAO LƯU",
    "wr-dashboard.notary.verify.view.file-info.date-notarized": "NGÀY CHỨNG THỰC",
    "wr-dashboard.notary.verify.view.button.cancel": "Hủy",
    "wr-dashboard.notary.verify.view.button.done": "Xong",
    "wr-dashboard.notary.warning.unsupported.browser.version": "Phiên bản trình duyệt không được hỗ trợ",
    "wr-dashboard.versions-dialog-box.title": "Phiên bản của {fileName}",
    "wr-dashboard.asign-dialog-box.title": "Gửi để ký",
    "wr-dashboard.asign-dialog-box.message": "Phiên bản tệp được chia sẻ nhưng chỉ những người có liên kết đến tệp mới có thể xem tệp. Tiếp tục đến ASign để thêm các bên ký tên và chia sẻ liên kết.",
    "wr-dashboard.asign-dialog-box.button.show-signed-file-details": "Hiển thị Chi tiết tệp",
    "wr-dashboard.page-not-found.title": "Không tìm thấy trang",
    "wr-dashboard.page-not-found.message.main": "Không tìm thấy trang bạn đang tìm kiếm.",
    "wr-dashboard.page-not-found.message.description": "Có thể liên kết đã lỗi thời hoặc bạn đã nhập sai địa chỉ.",
    "wr-dashboard.page-not-found.message.error": "Mã lỗi: 404",
    "wr-dashboard.server-error.title": "Máy chủ không sẵn dùng",
    "wr-dashboard.server-error.message": "Máy chủ không sẵn dùng lúc này. Vui lòng thử lại sau.",
    "wr-dashboard.server-error.message.error": "Mã lỗi: 500",
    "wr-dashboard.account-menu.action.sign-out": "Đăng xuất",
    "wr-dashboard.breadcrumb.item.machines": "Máy",
    "wr-dashboard.breadcrumb.item.failed-backups": "Bản sao lưu không thành công",
    "wr-dashboard.machines-table.column.name": "Tên",
    "wr-dashboard.machines-table.column.size": "Kích cỡ",
    "wr-dashboard.machines-table.message.no-machines": "Chưa có máy nào trong Đám mây",
    "wr-dashboard.incomplete-backups.message.status:plural": "Bạn có {count} bản sao lưu không thành công hoặc chưa hoàn tất chiếm {size} bộ nhớ | Bạn có {count} bản sao lưu không thành công hoặc chưa hoàn tất chiếm {size} bộ nhớ",
    "wr-dashboard.incomplete-backups.button.view": "Xem bản sao lưu",
    "wr-dashboard.incomplete-backups.button.delete": "Xóa bản sao lưu",
    "wr-dashboard.machines-table.message.space-used:plural": "Tổng mức sử dụng bản sao lưu {size}",
    "wr-dashboard.delete-archive-dialog-box.title": "Xóa bản lưu trữ",
    "wr-dashboard.delete-incomplete-archive-dialog-box.title": "Xóa bản lưu trữ chưa hoàn tất",
    "wr-dashboard.delete-all-incomplete-archives-dialog-box.title": "Xóa tất cả bản lưu trữ chưa hoàn tất",
    "wr-dashboard.delete-archive.message": "Bạn có chắc chắn muốn xóa vĩnh viễn các bản lưu trữ đã chọn khỏi tất cả vị trí không? Tất cả dữ liệu sẽ bị xóa và không thể khôi phục.",
    "wr-dashboard.delete-archive.deletion-warning-message": "Việc thực hiện bất kỳ thay đổi nào trong bảng điều khiển khôi phục web này có thể không được phản ánh trực quan trong ứng dụng tương ứng của bảng điều khiển bảo vệ nếu ứng dụng đó không trực tuyến, cũng như không có tác nhân nào trực tuyến để xử lý các thay đổi",
    "wr-dashboard.delete-archive.locked-error-message": "Bản lưu trữ đã bị khóa để đảm bảo tính thống nhất của dữ liệu. Vui lòng dừng tất cả thao tác với bản lưu trữ (ví dụ: duyệt, khôi phục, sao lưu) rồi thử lại.",
    "wr-dashboard.certificate-pending-dialog-box.title": "Chứng chỉ đang chờ xử lý",
    "wr-dashboard.certificate-pending-dialog-box.message": "Vui lòng thử lại sau vài phút.",
    "wr-dashboard.form.button.ok": "OK"
};
